(function(){
'use strict';
var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function each(list, fn){ Array.prototype.forEach.call(list, fn); }
function reveal(){
  var els = document.querySelectorAll('.nv-r:not(.nv-in), .nv-mask:not(.nv-in), .nv-line:not(.nv-in)');
  if (rm || !('IntersectionObserver' in window)) { each(els, function(e){ e.classList.add('nv-in'); }); return; }
  var io = new IntersectionObserver(function(entries){
    each(entries, function(en){ if (en.isIntersecting) { en.target.classList.add('nv-in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
  each(els, function(e){ io.observe(e); });
}
/* Header state: nv-scrolled once the page has moved, nv-down while scrolling down
   (the desktop bar slides away on nv-down and comes back as soon as you scroll up). */
function header(){
  var ticking = false;
  var last = window.scrollY;
  var down = false;
  function update(){
    var y = window.scrollY;
    document.body.classList.toggle('nv-scrolled', y > 40);
    if (y <= 120) { down = false; last = y; }
    else if (y > last + 8) { down = true; last = y; }
    else if (y < last - 8) { down = false; last = y; }
    document.body.classList.toggle('nv-down', down);
    ticking = false;
  }
  window.addEventListener('scroll', function(){ if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }, { passive: true });
  update();
}
function parallax(){
  if (rm) return;
  var els = document.querySelectorAll('[data-nv-par]');
  if (!els.length) return;
  var ticking = false;
  function update(){
    var vh = window.innerHeight;
    each(els, function(el){
      var r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var s = parseFloat(el.getAttribute('data-nv-par')) || 0.08;
      var p = (r.top + r.height / 2 - vh / 2) / vh;
      el.style.transform = 'translate3d(0,' + (p * s * 100).toFixed(2) + 'px,0)';
    });
    ticking = false;
  }
  window.addEventListener('scroll', function(){ if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }, { passive: true });
  window.addEventListener('resize', function(){ if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }, { passive: true });
  update();
}
/* Click tracking: sends named events to Shopify's own analytics (Customer events / pixels).
   Adds no tracking script of its own and does nothing if Shopify analytics is unavailable. */
function track(){
  document.addEventListener('click', function(ev){
    var el = ev.target && ev.target.closest ? ev.target.closest('[data-nv-track]') : null;
    if (!el) return;
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('narii_' + el.getAttribute('data-nv-track'), { url: el.getAttribute('href') || '', label: (el.textContent || '').trim().slice(0, 80) });
      }
    } catch (e) {}
  });
}
/* Safety net: if anything stops the reveal observer, show the content anyway. */
function failsafe(){
  window.setTimeout(function(){
    each(document.querySelectorAll('.nv-r:not(.nv-in), .nv-mask:not(.nv-in), .nv-line:not(.nv-in)'), function(e){
      var r = e.getBoundingClientRect();
      if (r.top < window.innerHeight) e.classList.add('nv-in');
    });
  }, 2500);
}
function init(){ reveal(); header(); parallax(); track(); failsafe(); }
if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
document.addEventListener('shopify:section:load', function(){ reveal(); parallax(); });
})();
